import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';
import PAGE_COMPONENT from './Lander';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <BrowserRouter>
        <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
            <PAGE_COMPONENT {...props} />
        </PAGE_CONTEXT>
    </BrowserRouter>
);
